import {postMethod} from '@/api'

export const post = async formData => await postMethod('/transactions/external/upload', formData)
